import { selectCurrentHotelId } from 'accessors'
import { PMSsWithSyncLoginSupport } from 'constants'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import choiceadvantage from '../../img/pms/choice-advantage.png'
import clock from '../../img/pms/clock-pms.png'
import infor from '../../img/pms/infor.png'
import maestro from '../../img/pms/maestro.png'
import marriottgxp from '../../img/pms/marriottgxp.png'
import ohip from '../../img/pms/ohip.png'
import roomkey from '../../img/pms/roomkey.png'
import skytouch from '../../img/pms/skytouch.png'
import webrezpro from '../../img/pms/webrezpro.png'
import styles from './PmsMessage.module.scss'

const logos = {
  webrezpro,
  choiceadvantage,
  skytouch,
  roomkey,
  marriottgxp,
  ohip,
  clock,
  maestro,
  infor
}

const PmsMessage = ({ type, pmsLoginLink }) => {
  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const pmsSyncStatuses = useSelector(s => s.pmsSyncStatus.list)
  const subsidiaryPMS = useSelector(s => s.login.subsidiaryPMS)

  const statusOfCurrentSubsidiary = pmsSyncStatuses?.find(
    s => s.subsidiaryId === currentSubsidiaryId
  )

  if (
    statusOfCurrentSubsidiary?.isAllReportsHealthy === true ||
    !PMSsWithSyncLoginSupport.includes(subsidiaryPMS)
  ) {
    return null
  }

  return (
    <div className={styles.headerContainer}>
      <div className={styles.logo}>
        {logos[type] ? <img src={logos[type]} alt={`${type} logo`} /> : null}
      </div>
      <p className={styles.text}>
        Enable PMS sync to automate uploads and get better conversions.
      </p>
      <NavLink to={pmsLoginLink}>
        <button className={styles.primaryButton}>Enable</button>
      </NavLink>
    </div>
  )
}

export default PmsMessage
